export const resources = {
  junior: {
    macos: [
      { name: 'Docker Documentation', url: 'https://docs.docker.com/', type: 'containerization' },
      { name: 'Kubernetes Basics', url: 'https://kubernetes.io/docs/tutorials/kubernetes-basics/', type: 'orchestration' },
      { name: 'AWS Getting Started', url: 'https://aws.amazon.com/getting-started/', type: 'cloud' },
      { name: 'Git Workflows', url: 'https://www.atlassian.com/git/tutorials/comparing-workflows', type: 'version-control' }
    ],
    windows: [
      { name: 'Azure DevOps Documentation', url: 'https://docs.microsoft.com/azure/devops/', type: 'platform' },
      { name: 'PowerShell Core Guide', url: 'https://docs.microsoft.com/powershell/', type: 'scripting' },
      { name: 'Windows Container Guide', url: 'https://docs.microsoft.com/virtualization/windowscontainers/', type: 'containerization' },
      { name: 'Azure Fundamentals', url: 'https://docs.microsoft.com/learn/paths/azure-fundamentals/', type: 'cloud' }
    ],
    linux: [
      { name: 'Linux System Administration', url: 'https://www.tldp.org/LDP/sag/html/', type: 'system' },
      { name: 'Bash Scripting Guide', url: 'https://www.gnu.org/software/bash/manual/', type: 'scripting' },
      { name: 'Ansible Documentation', url: 'https://docs.ansible.com/', type: 'automation' },
      { name: 'Nginx Configuration', url: 'https://nginx.org/en/docs/', type: 'web-server' }
    ]
  },
  mid: {
    macos: [
      { name: 'Terraform Documentation', url: 'https://www.terraform.io/docs/', type: 'infrastructure' },
      { name: 'Jenkins Pipeline Guide', url: 'https://www.jenkins.io/doc/book/pipeline/', type: 'ci-cd' },
      { name: 'Prometheus Monitoring', url: 'https://prometheus.io/docs/', type: 'monitoring' },
      { name: 'Helm Charts Guide', url: 'https://helm.sh/docs/', type: 'package-management' }
    ],
    windows: [
      { name: 'Azure Resource Manager', url: 'https://docs.microsoft.com/azure/azure-resource-manager/', type: 'infrastructure' },
      { name: 'Azure Pipelines', url: 'https://docs.microsoft.com/azure/devops/pipelines/', type: 'ci-cd' },
      { name: 'Azure Monitor', url: 'https://docs.microsoft.com/azure/azure-monitor/', type: 'monitoring' },
      { name: 'Chocolatey Package Manager', url: 'https://docs.chocolatey.org/', type: 'package-management' }
    ],
    linux: [
      { name: 'Kubernetes Advanced Concepts', url: 'https://kubernetes.io/docs/concepts/', type: 'orchestration' },
      { name: 'GitLab CI/CD', url: 'https://docs.gitlab.com/ee/ci/', type: 'ci-cd' },
      { name: 'Grafana Dashboards', url: 'https://grafana.com/docs/', type: 'visualization' },
      { name: 'Apache Kafka Operations', url: 'https://kafka.apache.org/documentation/', type: 'streaming' }
    ]
  },
  senior: {
    macos: [
      { name: 'Site Reliability Engineering', url: 'https://sre.google/books/', type: 'reliability' },
      { name: 'Cloud Architecture Patterns', url: 'https://docs.aws.amazon.com/architecture-center/', type: 'architecture' },
      { name: 'Security Best Practices', url: 'https://owasp.org/www-project-devops-guideline/', type: 'security' },
      { name: 'Chaos Engineering Principles', url: 'https://principlesofchaos.org/', type: 'reliability' }
    ],
    windows: [
      { name: 'Azure Well-Architected Framework', url: 'https://docs.microsoft.com/azure/architecture/framework/', type: 'architecture' },
      { name: 'Enterprise DevOps', url: 'https://docs.microsoft.com/azure/devops/learn/', type: 'enterprise' },
      { name: 'Azure Security Center', url: 'https://docs.microsoft.com/azure/security-center/', type: 'security' },
      { name: 'Microsoft Cloud Adoption Framework', url: 'https://docs.microsoft.com/azure/cloud-adoption-framework/', type: 'strategy' }
    ],
    linux: [
      { name: 'High Availability Systems', url: 'https://www.kernel.org/doc/html/latest/admin-guide/', type: 'reliability' },
      { name: 'Container Security', url: 'https://kubernetes.io/docs/concepts/security/', type: 'security' },
      { name: 'Distributed Systems Design', url: 'https://www.distributed-systems.net/', type: 'architecture' },
      { name: 'Performance Engineering', url: 'http://www.brendangregg.com/linuxperf.html', type: 'performance' }
    ]
  }
};
